import { IconWrapper, SelectCard } from "@caprikorn/dynamo-ui";
import { classNames } from "@caprikorn/dynamo-utils";
import type { FC } from "react";

import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./SelectEnergyForm.module.css";
import type { SelectPODEnergy } from "./SelectEnergyForm.types";

export const SelectEnergyForm: FC<SelectPODEnergy> = ({
  setEnergyType,
  energyType,
  setStep,
}) => {
  const { t } = useCustomTranslation(["main", "common"]);

  return (
    <div className={classes.container}>
      <h3 className={classNames(classes.titleContainer, "font-title-md")}>
        <IconWrapper role="presentation" size="2xl" src="dualChip" />
        {t("addPodDrawer.selectEnergy.title")}
      </h3>
      <div className={classes.cardContainer}>
        {(["ELEC", "GAS"] as const).map((energy) => (
          <SelectCard
            key={energy}
            checked={energyType === energy}
            className={classes.selectCard}
            description={
              energy === "GAS" ? t("soon", { ns: "common" }) : undefined
            }
            disabled={energy === "GAS"}
            illustration2={energy === "ELEC" ? "electricity" : "gas"}
            isMultiple={false}
            onChange={() => {
              setEnergyType(energy);
              setStep("podSerial");
            }}
            title={t(`energy.${energy}`, { ns: "common" })}
            value={energy}
          />
        ))}
      </div>
    </div>
  );
};
